

/* ============
* Login Index Page
* ============
*
* Page where the user can login.
*/


import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

export default {


/**
* The data that can be used by the page.
*
* @returns {Object} The view-model data.
*/
data() {
return {
content:'2017年度稳岗补贴申报时间时间：2018年2月26日至4月28日。详情请登录宁波就业创业局网',
params:{},
content:'',
showCancelMessage:false,
showSuccessMessage:false,
unitName:'',
registerCode:'',
licenceCode:''
};
},
components: {
Group,XInput,Toast
},

/**
* The methods the page can use.
*/
methods: {
/**
* Will log the user in.
*
* @param {Object} user The user to be logged in.
*/
next(){
if(this.unitName == '' || this.registerCode == '' || this.licenceCode){
this.showCancelMessage = true;
this.content = '数据填写不完整！'
}
this.$router.push({path: '/wg/next',query:{unitName:this.unitName,registerCode:this.registerCode,licenceCode:this.licenceCode}})
}
},
mounted () {

},
/**
* The components the page can use.
*/

};



// WEBPACK FOOTER //
// ./src/pages/wg/index.vue